// Used in all sheets
export enum Scope {
    BackwardPermanent = "Backward Permanent",
    BackwardTemporary = "Backward Temporary",
    PowerEnabling = "Power enabling",
    FinanceEnabling = "Finance Enabling",
}
